import { useEffect, useState } from "react";
import { Grid, Select, IconButton, MenuItem, Typography } from '@mui/material';
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ProductModal } from "./components/ProductModal/ProductModal";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { useProductImportStore } from "../../hooks/useProductImportStore";
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'text', field: 'status_import', label: 'Estado de la importación', align:'center', format:(row) => row.status_import == 0 ? 'Sin importar' : ( row.status_import == 1 ? 'Importado' : 'Eliminado') },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align:'center' },
];

export const ImportedProducts = () => {

    const { setActionImported, getImportedProducts, deleteImportedProduct, saveImportedProduct, saveImportedProductMassive } = useProductImportStore();

    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalImport, setShowModalImport] = useState<boolean>(false);
    const [selected, setSelected] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [typesearch, settypesearch] = useState<any>('0');
    const [statusimport, setstatusimport] = useState<any>('0');

    useEffect(() => {
        getImportedProductsApi()
    },[])

    const getImportedProductsApi = async(search='', status_import='0') => {
        try {
            setLoading(true);
            let response = await getImportedProducts({search:search, status_import: status_import})
            if(!response){
                setProducts([]); setLoading(false);
                return false;
            }else{
                if (status_import='0') {
                    response = response?.map(product => {
                        if (product.idtype == null) product.idtype = 1
                        return product
                    })
                }
                setProducts(response || []); setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = products.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const isSelected = (row) => {
        return selected.some(item => item.id === row.id);
    };

    const onEdit = (rowSelected:any) => {
        setActionImported('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionImported('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteImportedProduct(rowSelected.id)
            if(response){
                getImportedProductsApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }
    const onSaveImport = (rowSelected:any) => {
        setActionImported('import');
        setRowSelected(rowSelected);
        setShowModalImport(true);
    }
    const saveImportedProductApi = async() => {
        if (rowSelected) {
            try {
                setLoading(true);
                const response = await saveImportedProduct(rowSelected.id);
                if(response){
                    getImportedProductsApi();
                    setShowModalImport(false);
                    setLoading(false);
                    setRowSelected('');
                }else{
                    setLoading(false);
                    return false;
                }
            } catch (error) {
                setLoading(false);
            }
        }
    }

    const importMassiveApi = async() => {
        try {
            if(selected.length == 0) return CustomSnackbar('warning', "Debe seleccionar almenos un producto");
            const idproducts = selected.map(product => product.id);

            setLoading(true);
            const response = await saveImportedProductMassive({ids_products: idproducts});
            if(response){
                getImportedProductsApi(); setLoading(false); setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getImportedProductsApi(term, typesearch)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>


            <Grid item xs={12}>
                <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom:'10px'}}>
                    <Typography variant='h6' component='h1' gutterBottom sx={{ mt: 1, ml:1}} className='title-main'>
                        {'Productos cargados'}
                    </Typography>
                </Grid>
                <Grid item container xs={12} spacing={2} alignItems='center' sx={{marginBottom:'5px'}}>
                    <Grid item xs={10} md={2.5}>
                        <Select
                            id="type"
                            value={typesearch}
                            size="small"
                            onChange={(event) => { 
                                settypesearch(event.target.value);
                            }}
                            fullWidth
                        >
                            <MenuItem value={'1'}>{'Importados'}</MenuItem>;
                            <MenuItem value={'0'}>{'No importados'}</MenuItem>;
                        </Select>
                    </Grid>
                    <Grid item xs={2} md={3} display='flex' justifyContent='start' alignItems='center' sx={{padding:'0px'}}>
                        <button onClick={()=>{getImportedProductsApi('', typesearch); setstatusimport(typesearch)}} className="btn-search">
                            <IconButton aria-label="delete" size="small">
                                <SearchIcon fontSize="inherit" sx={{color:'#FFFFFF'}}/>
                            </IconButton>
                        </button>
                    </Grid>
                </Grid>
                <CustomTable 
                    disabled_title
                    columns={columns} 
                    loading={loading}
                    rows={products || []}
                    onRowClick={() => {}}
                    hasOptions
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCustomAction={statusimport == '0' && onSaveImport}
                    icon_CustomAction={ <SaveIcon fontSize="small" /> }
                    tooltip_CustomAction={'Importar'}
                    onCheckbox={onCheckbox}
                    isSelected={isSelected}
                    selectAll={handleSelectAllClick}
                    onSearch={onSearch}
                    onAddFn={statusimport == '0' && importMassiveApi}
                    onAddFnName={'Importar seleccionados'}
                    dense
                />
            </Grid>

            {
                showModal && (
                    <ProductModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        productSelected = {rowSelected}
                        listproducts = {getImportedProductsApi}
                        clearState = {clearState}
                        imported = {true}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
            {
                showModalImport && (
                    <ModalConfirm
                        open={showModalImport}
                        closeModal={()=>{ setShowModalImport(false); clearState()}}
                        onConfirm={saveImportedProductApi}
                        status={loading}
                        title={'Guardar producto importado'}
                        text={'Si estas seguro, haz click en el boton "aceptar" y el producto será guardado'}
                    />
                )
            }
        </>
    )
}